import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, ClockIcon, CarIcon, ShieldCheckIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function WhyChooseUs() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'Why travellers choose us',
      intro: 'Tourists in Ibiza want transport that is punctual, easy to arrange and comfortable. We focus on fast communication, smooth pickups and a professional experience for airport arrivals, villa stays, hotel transfers and special plans.',
      features: [{
        title: 'Fast booking',
        desc: 'Book your transfer in minutes by WhatsApp.',
        icon: MessageCircleIcon
      }, {
        title: 'Punctual service',
        desc: 'Reliable pickups at the agreed time and location.',
        icon: ClockIcon
      }, {
        title: 'Comfortable travel',
        desc: 'Clean, spacious and air-conditioned vehicles.',
        icon: CarIcon
      }, {
        title: 'Local professional drivers',
        desc: 'Friendly service with deep knowledge of Ibiza.',
        icon: ShieldCheckIcon
      }]
    },
    es: {
      title: 'Por qué los viajeros nos eligen',
      intro: 'Los turistas en Ibiza buscan un transporte puntual, fácil de organizar y cómodo. Nos centramos en responder rápido, organizar recogidas sin fricción y ofrecer una experiencia profesional para aeropuerto, villas, hoteles y planes especiales.',
      features: [{
        title: 'Reserva rápida',
        desc: 'Reserva tu traslado en minutos por WhatsApp.',
        icon: MessageCircleIcon
      }, {
        title: 'Servicio puntual',
        desc: 'Recogidas fiables en la hora y punto acordados.',
        icon: ClockIcon
      }, {
        title: 'Viajes cómodos',
        desc: 'Vehículos limpios, amplios y climatizados.',
        icon: CarIcon
      }, {
        title: 'Conductores locales profesionales',
        desc: 'Atención cercana y conocimiento profundo de Ibiza.',
        icon: ShieldCheckIcon
      }]
    }
  };
  const {
    title,
    intro,
    features
  } = content[language];
  return <section className="py-14 md:py-28 bg-warm-cream" data-id="element-320">
      <div className="mx-auto max-w-7xl px-5" data-id="element-321">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start" data-id="element-322">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-5" data-id="element-323">
            <h2 className="text-3xl md:text-4xl font-heading text-navy mb-4" data-id="element-324">
              {title}
            </h2>
            <div className="w-12 h-px bg-gold-subtle/50 mb-6" data-id="element-325" />
            <p className="text-slate leading-relaxed" data-id="element-326">{intro}</p>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-5" data-id="element-327">
            {features.map((feature, index) => {
            const Icon = feature.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5,
              delay: index * 0.08
            }} className="bg-white p-5 md:p-6 rounded-xl border border-stone/10 shadow-sm" data-id="element-328">
                  <div className="w-10 h-10 rounded-lg bg-navy/[0.04] flex items-center justify-center text-navy mb-4" data-id="element-329">
                    <Icon className="w-5 h-5" data-id="element-330" />
                  </div>
                  <h3 className="text-base font-heading text-navy mb-2" data-id="element-331">
                    {feature.title}
                  </h3>
                  <p className="text-slate text-sm leading-relaxed" data-id="element-332">
                    {feature.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}